import { Typography } from "@spz/ui/components/typography";
import type { FC } from "react";

interface ResultTitleProps {
  controlResultId: string;
  descriptorName: string;
}

const ResultTitle: FC<ResultTitleProps> = ({
  controlResultId,
  descriptorName,
}) => {
  return (
    <Typography
      trans="result_details_sheet_title"
      className="font-normal text-gray-900"
      transParams={{
        id: controlResultId,
        descriptorName,
      }}
      variant={"h5"}
    />
  );
};

export default ResultTitle;
